<template>
  <div class='container'>
    <div class='col-sm-10'>
      <h1>Måltidsenheter</h1>
      <hr />
      <div class='form'>
        <div class='summary text-red' v-if='$v.form.$error'>
          Enter number!
        </div>
        <br />
        <form @submit.prevent='submit'>
          <b-row>
            <b-col>
              <label for='form.total'>Ange ditt totala inslunintag</label>
              <b-form-input
                id='form.total'
                v-model='form.total'
                number
                placeholder='Enter first number'
                type='number'
                :class='{ hasError: $v.form.total.$error }'
                @input='$v.form.total.$touch()'
                :state='!$v.form.total.$error && null'
              ></b-form-input>
            </b-col>
            <b-col>
              <label for='form.carb'>Ange måltidens kolhydrater</label>
              <b-form-input
                id='form.carb'
                v-model='form.carb'
                number
                placeholder='Enter second number'
                :class='{ hasError: $v.form.carb.$error }'
                type='number'
                @input='$v.form.carb.$touch()'
                :state='!$v.form.carb.$error && null'
              ></b-form-input>
            </b-col>
          </b-row>
          <br />
          <br />
          <b-form-checkbox id='morning_checkbox' v-model='form.morning' name='morning_checkbox'>
            Är det morgon?
          </b-form-checkbox>
          <br />
          <br />
          <b-button type='submit' class='btn btn-sm' @click='onSubmitCalc'>Calculate</b-button>
          <br />
        </form>
      </div>
      <div class='mt-2' v-if='show'>Du borde ta ca {{ text }} enheter</div>
    </div>
    <br />
    <br />
    <div class='col-sm-10'>
      <h1>Korrigeringsenheter</h1>
      <hr />
      <br />
      <div class='form_corr'>
        <div class='summary text-red' v-if='$v.form_corr.$error'>
          Enter number!
        </div>
        <br />
        <form @submit.prevent='submit'>
          <b-row>
            <b-col>
          <label for='form_corr.current'>Nuvarande</label>
          <b-form-input
            id='form_corr.current'
            v-model='form_corr.current'
            number
            placeholder='Enter first number'
            type='number'
            :class='{ hasError: $v.form_corr.current.$error }'
            @input='$v.form_corr.current.$touch()'
            :state='!$v.form_corr.current.$error && null'>
            </b-form-input>
            </b-col>
          <b-col>
          <label for='form_corr.wanted'>Vill till</label>
          <b-form-input
            id='form_corr.wanted'
            v-model='form_corr.wanted'
            number
            placeholder='Enter second number'
            :class='{ hasError: $v.form_corr.wanted.$error }'
            type='number'
            @input='$v.form_corr.wanted.$touch()'
            :state='!$v.form_corr.wanted.$error && null'
          ></b-form-input>
          </b-col>
          </b-row>
          <br />
          <br />
          <b-button type='submit' class='btn btn-sm' @click='onSubmitCorr'>Calculate</b-button>
          <br />
        </form>
        <br />
      </div>
      <div class='mt-2' v-if='show_current'>Du borde ta ca {{ text_current }} enheter</div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      form: {
        total: 62,
        carb: '',
        morning: false,
      },
      form_corr: {
        current: '',
        wanted: '',
      },
      text: '',
      text_current: '',
      show: false,
      show_current: false,
    };
  },
  methods: {
    onSubmitCalc(evt) {
      evt.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$error) return;
      if (this.form.morning) {
        this.text = (this.form.carb / (300 / this.form.total)).toFixed(1);
        this.show = true;
      } else {
        this.text = (this.form.carb / (500 / this.form.total)).toFixed(1);
        this.show = true;
      }
    },
    onSubmitCorr(evt) {
      evt.preventDefault();
      this.$v.form_corr.$touch();
      if (this.$v.form_corr.$error) return;
      this.text_current = (
        this.form_corr.current - this.form_corr.wanted) / (100 / this.form.total);
      this.show_current = true;
    },
  },
  validations: {
    form: {
      total: { required },
      carb: { required },
    },
    form_corr: {
      current: { required },
      wanted: { required },
    },
  },
};
</script>
